import { h } from 'preact'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import bingImageExists from '../hocs/imageExists'
import { ImageVersionType } from '../reducers'

const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  vertical-align: middle;
`

const StyledImg = styled.img`
  width: 100%;
  vertical-align: middle;
`

const Image = bingImageExists()(StyledImg)

const Img = ({ className, fallbackSrc, itemStatus, itemVersion }) => {
  const src = itemVersion && itemStatus === 'success' ? itemVersion.url : fallbackSrc
  const title = itemVersion ? itemVersion.title : 'placeholder'

  return (
    <Wrapper className={className}>
      <Image src={src} fallbackSrc={fallbackSrc} alt={title} title={title} />
    </Wrapper>
  )
}

Img.propTypes = {
  itemVersion: ImageVersionType,
  fallbackSrc: PropTypes.string.isRequired,
  className: PropTypes.string,
  itemStatus: PropTypes.string
}

Img.defaultProps = {
  itemVersion: null,
  className: '',
  itemStatus: '',
  withGradient: false
}

export default styled(Img)``



// WEBPACK FOOTER //
// ./src/components/Img.js